const FEATURE_HOME_SECTION_ID = -1

export { FEATURE_HOME_SECTION_ID }
